
<template>
  <div>
    <dialog-loading loadingText="Enviando" v-if="saving"></dialog-loading>
    <div class="pt-4 pb-4">
      <v-card flat outlined>
        <v-card-title class="pa-0">
          <div>
           <div class="py-2 pl-2" max-height="70" max-width="70" min-height="70" min-width="70">
              <div style="background-color: #eee; width: 70px; height: 70px; font-size: 35px; border-radius: 3px" class="d-flex align-center justify-center">
                <span v-if="!logo_url">{{ initials }}</span>
                <v-img v-if="logo_url" :src="logo_url" style="border-radius: 3px" max-height="70" max-width="70" min-height="70" min-width="70"></v-img>
              </div>

           </div>
          </div>
          <div class="pa-3">
            <v-row >
              <span class="ml-3" style="white-space: nowrap; color: #4c4c4c">Nova solicitação 📨</span>
            </v-row>
            <v-row>
              <span class="text-subtitle-1 ml-3" style="white-space: nowrap; color: #4c4c4c"><b>Empresa:</b>  {{ company_name }}  </span>
            </v-row>
          </div>
        </v-card-title>
      </v-card>
    </div>
    <v-form ref="form_info" :disabled="!is_editing && !!event_negotiation.id" v-model="valid" v-if="!loading">
      <default-card style="">
        <!-- <template slot="title-left"> DADOS DO EVENTO </template> -->
        <template slot="content">
          <v-card outlined class="mb-1 mx-1 mt-n1">
            <v-card-title class="content-border-title pl-4 pa-1">
              Dados do evento
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <div class="px-8">
                <v-row class="pt-6">
                  <v-col class="py-0" cols="12" md="4">
                    <calendar-date-picker
                      @datePicked="handleDataPickStartAt"
                      :min="this.$dayjs().format('YYYY-MM-DD').toString()"
                      :date="event_negotiation.start_at"
                      is_component_show_event
                      label="Data do evento"
                      dense outlined inner_icon
                      :is_readonly="!is_editing && !!event_negotiation.id"
                    />
                  </v-col>
                  <v-col class="py-0" cols="12" md="8">
                    <v-text-field dense outlined v-model="event_negotiation.name" :rules="required" label="Nome do evento"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12" sm="6">
                    <v-text-field dense outlined v-model="event_negotiation.event_detail_attributes.city" label="Cidade"></v-text-field>
                  </v-col>
                  <v-col class="py-0" cols="12" sm="6">
                    <v-select :menu-props="{ bottom: true, offsetY: true }" :rules="required" dense outlined :items="state_items" label="Estado" v-model="event_negotiation.event_detail_attributes.state"></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12" md="6">
                    <v-select 
                      :menu-props="{ bottom: true, offsetY: true }"
                      dense
                      outlined
                      class="comp-text pa-0"
                      v-model="event_negotiation.event_detail_attributes.size"
                      :items="peoples"
                      :item-value="peoples.value"
                      :item-text="peoples.text"
                      :rules="required"
                      label="Público"
                    ></v-select>
                  </v-col>
                  <v-col class="py-0" cols="12" md="6">
                    <v-select 
                      :menu-props="{ bottom: true, offsetY: true }"
                      dense
                      outlined
                      class="comp-text pa-0"
                      v-model="event_negotiation.kind"
                      :items="kinds"
                      :item-value="kinds.value"
                      :item-text="kinds.text"
                      :rules="required"
                      label="Perfil do evento"
                    ></v-select>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </v-card>
          <v-card outlined class="mb-4 mx-1 mt-4">
            <v-card-title class="content-border-title pl-4 pa-1">
              Dados do contato
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text>
              <div class="px-8">
                <v-row class="pt-5">
                  <v-col class="py-0" cols="12" md="6">
                    <v-text-field
                      dense
                      outlined
                      class="comp-text pa-0"
                      v-model="event_negotiation.event_contact_attributes.responsible_name"
                      :rules="required"
                      label="Nome do responsável"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0" cols="12" md="6">
                    <v-select 
                      :menu-props="{ bottom: true, offsetY: true }"
                      dense
                      outlined
                      class="comp-text pa-0"
                      v-model="event_negotiation.event_contact_attributes.responsible_kind"
                      :items="responsible_kinds"
                      :item-value="responsible_kinds.value"
                      :item-text="kinds.text"
                      :rules="required"
                      label="Conexão"
                    ></v-select>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="py-0" cols="12" md="6">
                    <v-text-field
                      prepend-inner-icon="mdi-phone"
                      dense
                      outlined
                      class="comp-text pa-0"
                      v-model="event_negotiation.event_contact_attributes.responsible_phone"
                      :rules="required"
                      label="Telefone"
                    ></v-text-field>
                  </v-col>
                  <v-col class="py-0" cols="12" md="6">
                    <v-text-field
                      prepend-inner-icon="mdi-at"
                      dense
                      outlined
                      class="comp-text pa-0"
                      v-model="event_negotiation.event_contact_attributes.responsible_email"
                      :rules="emailRules" 
                      label="Email"
                    ></v-text-field>
                  </v-col>
                </v-row>
              </div>
            </v-card-text>
          </v-card>
          <v-row>
            <v-col>
              <div>
                <v-btn block color="black" text dense class="mr-n1 title-financial btn-success"
                  @click="is_editing = true" 
                  :disabled="!valid" v-if="event_negotiation.id && !is_editing && event_negotiation.status == 'open'"
                >EDITAR</v-btn>
                <v-btn 
                  block color="black" text dense class="mr-n1 title-financial btn-primary"
                  @click="submitNegotiation()" 
                  :disabled="!valid" 
                  v-if="!event_negotiation.id || is_editing"
                >
                  {{!event_negotiation.id ? 'ENVIAR' : 'SALVAR'}}
                </v-btn>
    
                <v-btn block color="black" text dense class="mr-n1 title-financial btn-error" 
                  @click="[getNegotiation(), is_editing = false]" 
                  :disabled="!valid" v-if="event_negotiation.id && is_editing"
                >
                  CANCELAR
                </v-btn>
              </div>
              <div v-if="event_negotiation.status != 'open' && event_negotiation.id">
                <v-alert
                  :type="statuses_map[event_negotiation.status].type"
                >
                  Status: <span style="font-weight: bold;"> {{statuses_map[event_negotiation.status].text}} </span> 
                </v-alert>
              </div>
            </v-col>
          </v-row>
        </template>
      </default-card>
    </v-form>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import validations from "@/mixins/validations";
import Api from '@/api/index'

export default {
  name: 'NegotiationForm',
  mixins: [ validations ],
  components: {
    CalendarDatePicker: () => import ('@/components/events_agenda/calendar/CalendarDatePicker.vue'),
    ShowLogo: () => import ('../../shared/ShowLogo.vue'),
  },
  props: {
    negotiation: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      valid: true,
      event_negotiation: {
        id: null,
        start_at: this.$dayjs().add(3, 'd').format('YYYY-MM-DD') ,  
        name: '' ,  
        kind: '' ,  
        event_contact_attributes: {
          responsible_name: '' ,  
          responsible_phone: '' ,  
          responsible_email: '' ,  
          responsible_kind: '' ,  
        },
        event_detail_attributes: {
          state: '',
          city: '',
          size: '' ,
          address: ''
        },
        status: 'in_negociation'
      },
      saving: false,
      loading: false,
      is_editing: false,
      comment: '',

      peoples: [
        { value: 'smallest', text: '0 - 100 Pessoas' },
        { value: 'smaller', text: '100 - 400 Pessoas' },
        { value: 'small', text: '400 - 700 Pessoas' },
        { value: 'medium', text: '700 - 1400  Pessoas' },
        { value: 'big', text: '1400 - 4000  Pessoas' },
        { value: 'bigger', text: '4000 - 10000 Pessoas' },
        { value: 'biggest', text: '10000 - 40000 Pessoas' },
        { value: 'xbiggest', text: '40000+ Pessoas' },
      ],
      kinds: [
        { text: 'Social', value: 'social' },
        { text: 'Corporativo', value: 'corporative' },
        { text: 'Cultural', value: 'cultural' },
        { text: 'Eletrônico', value: 'eletronic' },
        { text: 'Festival', value: 'festival' },
        { text: 'Congresso/Feira', value: 'congress' },
        { text: 'Bar/Restaurante', value: 'restaurant' },
        { text: 'Outros', value: 'other' },
      ],
      responsible_kinds: [
        { value: 'producer', text: 'Produtor' }, 
        { value: 'owner', text: 'Proprietário' }, 
        { value: 'collaborator', text: 'Colaborador' }
      ],
      statuses_map:{
        converted: { text: 'Confirmado', type: 'success' },
        closed: { text: 'Negado', type: 'error' },
      },
      company_data: {},
      state_items: [],
    }
  },
  methods: {
    handleDataPickStartAt(e){
      this.event_negotiation.start_at = e
    },
    submitNegotiation(){
      if(this.$refs.form_info.validate() && this.has_token){
        this.swallConfirmation({msg: 'Deseja realizar o envio?'}).then(r=> {
          if(r){
            this.saveNegotiation(this.event_negotiation)
          }
        })
      } else if (!this.has_token){
        this.addNotification({type: 'error', msg: `Link quebrado! Verifique e tente novamente.`})
      }
    },
    async getData(){
      await this.getCompanyName()
      await this.getStateItems()
    },
    async getCompanyName(){
      if(this.$route.query.tk){
        await Api.Event.showCompanyNameByToken({company_token: this.$route.query.tk}).then(r=>r.data).then(d=> {
          this.company_data = d
        })
      }
    },
    async getStateItems(){
      let url = 'https://servicodados.ibge.gov.br/api/v1/localidades/estados';
      await fetch(url)
      .then(response => response.json())
      .then(data => {        
        data.sort((a,b) => a.nome.localeCompare(b.nome));
        data.map((state)=>{
          this.state_items.push(state.sigla)
        })
      });
    },
    saveNegotiation(negotiation){
      const ACTION = 'createNegotiation' // this.$route.params.negotiation_id ? 'update' : 'create'
      
      this.saving = true
      const {city, state} = negotiation.event_detail_attributes
      negotiation.event_detail_attributes.address = `${'Rua: '}, ${'Bairro: '}, ${city || 'Cidade: '}, ${state || 'Estado: '}`+', Nº: '
      let obj = {
        ...negotiation,
        company_token: this.page_token
      }

      Api.Event[ACTION](obj).then(() => {
        this.addNotification({type: 'success', msg: 'Realizado com sucesso'})
        let route_name = {name:'ConfirmSended'} // this.user ? {name:'Negotiations'} : {name:'ConfirmSended'}
        this.$router.push(route_name)
      }).catch((err) => {
        console.log({err})
        let e_msg = null
        if (err.response && err.response.data && err.response.data.errors){
          e_msg = err.response.data.errors
        }
        this.addNotification({type: 'error', msg: `Não foi possível concluir a ação, tente novamente. Erro: ${err.response.status} ${e_msg || ''}`})
      }).finally(() => {
        setTimeout(() => {
          this.saving = false
          this.is_editing = false
        }, 700);
      })
    },
    swallConfirmation(swall_message){
      return this.$swal({
        showConfirmButton: true,
        showCancelButton: true,
        cancelButtonText: 'Cancelar',
        title: swall_message.msg,
        icon: 'question',
      }).then(r=>{
        if (r.isConfirmed) {
          return r.isConfirmed
        };
      });
    },
    ...mapActions({
      addNotification: 'Notification/add',
    })
  },
  computed: {
    initials() {
      if(this.company_data.name){
        let text = this.company_data.name.substring(0, 2)
        return text.toUpperCase();
      }else{
        return ''
      }

    },
    company_name(){
      return this.company_data.name
    },
    logo_url(){
      return this.company_data.logo_url
    },
    has_token(){
      return !!this.$route.query.tk
    },
    page_token(){
      return this.$route.query.tk
    },
    ...mapState({
      user: state => state.User.user,
      activeCompanyId: state => state.App.activeCompanyId,
      activeCompany: state => state.App.activeCompany,
    })
  },
  mounted () {
    this.getData()
  },
}
</script>

<style scoped>

.headers-title{
  color: white;
  font-size: 1.7rem !important;
  font-weight: 500;
  line-height: 2rem;
  letter-spacing: 0.05em !important;
  font-family: "Roboto", sans-serif !important;
  text-transform: uppercase !important;
  border-radius: 4px;
}

.comp-text{
  /* color: white;
  font-weight: 400;
  letter-spacing: 0.05em !important;
  font-family: "Roboto", sans-serif !important; */
}

.btn-text{
  color: white;
  font-weight: 400;
  letter-spacing: 0.05em !important;
  font-size: 1.1rem !important;
  font-family: "Roboto", sans-serif !important;
  text-transform: uppercase !important;
}
.title-header{
  white-space: nowrap; 
  
}


@media only screen and (max-width: 600px) {
  .headers-title{
    color: white;
    font-size: 1.6rem !important;
    font-weight: 500;
  }
}

@media only screen and (max-width: 300px) {
  .headers-title{
    color: white;
    font-size: 1.3rem !important;
    font-weight: 500;
  }
}

</style>